import { Injectable, inject } from '@angular/core';
import { BaseCommandRepository } from '@okcargo-apps/shared-infrastructure';
import {
  AcceptFreightOfferCommand,
  AcceptFreightOfferCommandHandler,
  CreateFreightBatchCommand,
  CreateFreightBatchCommandHandler,
  CreateFreightWithStopsAndAssignationsCommand,
  CreateFreightWithStopsAndAssignationsCommandHandler,
  RejectFreightOfferCommand,
  RejectFreightOfferCommandHandler,
  UpdateFreightCommand,
  UpdateFreightCommandHandler,
  UpdateFreightStopCommand,
  UpdateFreightStopCommandHandler,
} from '@okcargo/command-processor';

@Injectable({ providedIn: 'root' })
export class FreightShipperCommandService {
  private readonly acceptFreightOfferCommandHandler: AcceptFreightOfferCommandHandler;
  private readonly rejectFreightOfferCommandHandler: RejectFreightOfferCommandHandler;
  private readonly createFreightWithStopsAndAssignationsCommandHandler: CreateFreightWithStopsAndAssignationsCommandHandler;
  private readonly createFreightBatchCommandHandler: CreateFreightBatchCommandHandler;
  private readonly updateFreightCommandHandler: UpdateFreightCommandHandler;
  private readonly updateFreightStopCommandHandler: UpdateFreightStopCommandHandler;

  constructor() {
    const commandRepository = inject(BaseCommandRepository);

    this.acceptFreightOfferCommandHandler = new AcceptFreightOfferCommandHandler(commandRepository);
    this.rejectFreightOfferCommandHandler = new RejectFreightOfferCommandHandler(commandRepository);
    this.createFreightWithStopsAndAssignationsCommandHandler = new CreateFreightWithStopsAndAssignationsCommandHandler(
      commandRepository,
    );
    this.createFreightBatchCommandHandler = new CreateFreightBatchCommandHandler(commandRepository);
    this.updateFreightCommandHandler = new UpdateFreightCommandHandler(commandRepository);
    this.updateFreightStopCommandHandler = new UpdateFreightStopCommandHandler(commandRepository);
  }

  acceptFreightOffer(command: AcceptFreightOfferCommand): Promise<void> {
    return this.acceptFreightOfferCommandHandler.handle(command);
  }

  rejectFreightOffer(command: RejectFreightOfferCommand): Promise<void> {
    return this.rejectFreightOfferCommandHandler.handle(command);
  }

  createFreightWithStopsAndAssignations(command: CreateFreightWithStopsAndAssignationsCommand): Promise<void> {
    return this.createFreightWithStopsAndAssignationsCommandHandler.handle(command);
  }

  createFreightBatch(command: CreateFreightBatchCommand): Promise<void> {
    return this.createFreightBatchCommandHandler.handle(command);
  }

  updateFreight(command: UpdateFreightCommand): Promise<void> {
    return this.updateFreightCommandHandler.handle(command);
  }

  updateFreightStop(command: UpdateFreightStopCommand): Promise<void> {
    return this.updateFreightStopCommandHandler.handle(command);
  }
}
